import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../../core/services/base-api.service';
import { 
  ImpressionsVsConversion as ConversionTrend, 
  HumCampaignFilterOptions 
} from '../hum-campaigns.model';
import { AppConfigService } from '../../../core/services/app-config.service';

// Add FunnelStage interface here for typing
interface FunnelStage {
  stage: string;
  count: number;
  percentage: number;
}

@Injectable({
  providedIn: 'root'
})
export class HumCampaignsService extends BaseApiService {
  constructor(http: HttpClient, appConfigService: AppConfigService) {
    super(http, appConfigService);
  }

  /**
   * Get HUM funnel data
   */
  getHumFunnel(filters: HumCampaignFilterOptions): Observable<FunnelStage[]> {
    // Create URL parameters
    let params = new HttpParams();
    if (filters.fromDate) {
      params = params.set('fromDate', filters.fromDate);
    }
    if (filters.toDate) {
      params = params.set('toDate', filters.toDate);
    }
    if (filters.campaignCode) {
      params = params.set('campaignCode', filters.campaignCode);
    }

    return this.http.get<FunnelStage[]>(`${this.apiUrl}/campaigns/hum-funnel`, { params });
  }

  /**
   * Get conversions vs dismissals month-wise data
   */
  getImpressionsVsConversion(filters: HumCampaignFilterOptions): Observable<ConversionTrend[]> {
    // Create URL parameters
    let params = new HttpParams();
    if (filters.fromDate) {
      params = params.set('fromDate', filters.fromDate);
    }
    if (filters.toDate) {
      params = params.set('toDate', filters.toDate);
    }
    if (filters.campaignCode) {
      params = params.set('campaignCode', filters.campaignCode);
    }

    return this.http.get<ConversionTrend[]>(`${this.apiUrl}/campaigns/conversion-trend`, { params });
  }
} 